import { render } from "./Button.vue?vue&type=template&id=c1246826&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=c1246826&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c1246826"

export default script